export const JOBS = [
  {
    id: 1,
    title: 'Bäckereiverkäufer/in',
    company: 'Laxner Bäckerei GmbH',
    logo: null,
    location: 'Kaiserslautern',
    type: 'Minijob',
    salary: '12,00 €/Stunde',
    tags: ['Verkauf', 'Bäckerei', 'Kundenkontakt'],
    posted: 'Heute',
    description: 'Wir suchen eine freundliche Aushilfe für unsere Filiale. Du bedienst Kunden, belegst Brötchen und hältst die Theke sauber. Flexible Früh- und Spätschichten möglich.',
    category: 'Gastronomie',
    isNew: true,
    isFeatured: false,
    applicants: 4,
  },
  {
    id: 2,
    title: 'Kassierer/in Supermarkt',
    company: 'Grunto Handel KG',
    logo: null,
    location: 'Ramstein-Miesenbach',
    type: 'Minijob',
    salary: '12,50 €/Stunde',
    tags: ['Kasse', 'Einzelhandel', 'Teamarbeit'],
    posted: 'Heute',
    description: 'Für unseren Supermarkt suchen wir zuverlässige Kassenaushilfen an Wochenenden und Feiertagen. Quereinstieg willkommen, Einarbeitung inklusive.',
    category: 'Einzelhandel',
    isNew: true,
    isFeatured: false,
    applicants: 7,
  },
  {
    id: 3,
    title: 'Servicekraft Restaurant',
    company: 'Würpel & Co OHG',
    logo: null,
    location: 'Homburg',
    type: 'Minijob',
    salary: '13,00 €/Stunde',
    tags: ['Service', 'Gastronomie', 'Abendschicht'],
    posted: 'Vor 1 Tag',
    description: 'Unser Restaurant sucht Verstärkung für Freitag- und Samstagabend. Du nimmst Bestellungen auf, servierst Speisen und sorgst für zufriedene Gäste.',
    category: 'Gastronomie',
    isNew: true,
    isFeatured: true,
    applicants: 3,
  },
  {
    id: 4,
    title: 'Tankstellenkassierer/in',
    company: 'Brekstad OHG',
    logo: null,
    location: 'Pirmasens',
    type: 'Minijob',
    salary: '12,00 €/Stunde',
    tags: ['Kasse', 'Tankstelle', 'Nachtschicht'],
    posted: 'Vor 2 Tagen',
    description: 'Wir suchen eine Aushilfe für unsere Tankstelle. Aufgaben: Kassieren, Regalbestückung und allgemeine Ordnung im Shop. Früh- und Spätschichten verfügbar.',
    category: 'Einzelhandel',
    isNew: false,
    isFeatured: false,
    applicants: 2,
  },
  {
    id: 5,
    title: 'Nachhilfelehrer/in Mathematik',
    company: 'Zorbex Bildung GmbH',
    logo: null,
    location: 'Kaiserslautern',
    type: 'Minijob',
    salary: '15,00 €/Stunde',
    tags: ['Mathe', 'Nachhilfe', 'Schüler', 'Didaktik'],
    posted: 'Heute',
    description: 'Du bist gut in Mathe und möchtest dein Wissen weitergeben? Wir vermitteln dich an Schüler/innen der Klassen 5–10. Flexible Zeiten, du bestimmst deinen Stundenplan.',
    category: 'Bildung',
    isNew: true,
    isFeatured: true,
    applicants: 6,
  },
  {
    id: 6,
    title: 'Lagerhilfe / Kommissionierung',
    company: 'Flentag Logistik KG',
    logo: null,
    location: 'Ramstein-Miesenbach',
    type: 'Minijob',
    salary: '12,50 €/Stunde',
    tags: ['Lager', 'Kommissionierung', 'körperlich'],
    posted: 'Vor 3 Tagen',
    description: 'Für unser kleines Lager suchen wir Aushilfen für das Verpacken und Sortieren von Waren. Keine Vorkenntnisse nötig. Gute Laune und Zuverlässigkeit reichen.',
    category: 'Logistik',
    isNew: false,
    isFeatured: false,
    applicants: 5,
  },
  {
    id: 7,
    title: 'Barista / Café-Hilfe',
    company: 'Klumba Gastronomie GmbH',
    logo: null,
    location: 'Kaiserslautern',
    type: 'Teilzeit',
    salary: '13,00 €/Stunde',
    tags: ['Kaffee', 'Barista', 'Café', 'Teilzeit'],
    posted: 'Heute',
    description: 'Unser Café sucht eine aufgeschlossene Teilzeitkraft. Du bereitest Kaffeespezialitäten zu, bäckst Kuchen auf und sorgst für eine gemütliche Atmosphäre. 15–20 Std./Woche.',
    category: 'Gastronomie',
    isNew: true,
    isFeatured: false,
    applicants: 9,
  },
  {
    id: 8,
    title: 'Fahrradkurier / Lieferdienst',
    company: 'Torven Services UG',
    logo: null,
    location: 'Pirmasens',
    type: 'Minijob',
    salary: '13,50 €/Stunde',
    tags: ['Fahrrad', 'Lieferung', 'outdoor', 'flexibel'],
    posted: 'Vor 4 Tagen',
    description: 'Liefere Pakete und Lebensmittel per Fahrrad durch die Innenstadt. Du kennst dich in Pirmasens aus und bist wetterresistent? Dann bist du bei uns richtig!',
    category: 'Logistik',
    isNew: false,
    isFeatured: false,
    applicants: 1,
  },
  {
    id: 9,
    title: 'Reinigungskraft Bürogebäude',
    company: 'Strondex Facility GmbH',
    logo: null,
    location: 'Pirmasens',
    type: 'Minijob',
    salary: '12,00 €/Stunde',
    tags: ['Reinigung', 'Gebäudereinigung', 'morgens'],
    posted: 'Vor 5 Tagen',
    description: 'Wir suchen eine zuverlässige Reinigungskraft für Büros in Pirmasens. Einsatz montags bis freitags von 6–8 Uhr. Reinigungsmittel werden gestellt.',
    category: 'Dienstleistung',
    isNew: false,
    isFeatured: false,
    applicants: 3,
  },
  {
    id: 10,
    title: 'IT-Praktikum (m/w/d)',
    company: 'Nexbar Systems OHG',
    logo: null,
    location: 'Ramstein-Miesenbach',
    type: 'Praktikum',
    salary: '400,00 €/Monat',
    tags: ['IT', 'Windows', 'Support', 'Praktikum'],
    posted: 'Vor 1 Tag',
    description: '3-monatiges Praktikum in unserem IT-Support-Team. Du lernst Netzwerkgrundlagen, hilfst bei Hardware-Aufbau und begleitest Kundentermine. Ideal für Schüler/innen mit IT-Interesse.',
    category: 'Technologie',
    isNew: true,
    isFeatured: true,
    applicants: 11,
  },
  {
    id: 11,
    title: 'Schülerhilfe Grundschule',
    company: 'Felpaz Bildung GmbH',
    logo: null,
    location: 'Homburg',
    type: 'Minijob',
    salary: '14,00 €/Stunde',
    tags: ['Betreuung', 'Grundschule', 'Kinder', 'Nachmittag'],
    posted: 'Vor 2 Tagen',
    description: 'Du begleitest Grundschüler/innen beim Mittagessen und in den Hausaufgaben. Montag bis Donnerstag 12–16 Uhr. Erfahrung mit Kindern erwünscht, aber kein Muss.',
    category: 'Bildung',
    isNew: false,
    isFeatured: false,
    applicants: 4,
  },
  {
    id: 12,
    title: 'Verkäufer/in Drogeriemarkt',
    company: 'Berthal Handel KG',
    logo: null,
    location: 'Kaiserslautern',
    type: 'Minijob',
    salary: '12,50 €/Stunde',
    tags: ['Drogerie', 'Verkauf', 'Beratung', 'Regal'],
    posted: 'Vor 3 Tagen',
    description: 'Wir suchen freundliche Aushilfen für Kasse und Regalbestückung in unserem Drogeriemarkt. Verschiedene Schichten möglich, perfekt neben der Schule oder dem Studium.',
    category: 'Einzelhandel',
    isNew: false,
    isFeatured: false,
    applicants: 6,
  },
  {
    id: 13,
    title: 'Lagerhelfer/in Lebensmittel',
    company: 'Dorfax Handels GmbH',
    logo: null,
    location: 'Ramstein-Miesenbach',
    type: 'Teilzeit',
    salary: '13,00 €/Stunde',
    tags: ['Lager', 'Lebensmittel', 'Teilzeit', 'Kühllager'],
    posted: 'Heute',
    description: 'Für unser Lebensmittellager suchen wir eine Teilzeitkraft 20 Std./Woche. Aufgaben: Warenannahme, Einlagerung, Kühllager. Körperliche Belastbarkeit vorausgesetzt.',
    category: 'Logistik',
    isNew: true,
    isFeatured: false,
    applicants: 2,
  },
  {
    id: 14,
    title: 'Küchenhilfe / Spüler (m/w/d)',
    company: 'Grumfeld Gastronomie OHG',
    logo: null,
    location: 'Homburg',
    type: 'Minijob',
    salary: '13,00 €/Stunde',
    tags: ['Küche', 'Spülen', 'Restaurant', 'Abendschicht'],
    posted: 'Vor 1 Woche',
    description: 'Unser Restaurant sucht eine zuverlässige Küchenhilfe für Abendschichten. Du unterstützt das Küchenteam beim Spülen, Sauberhalten und Vorbereiten. Keine Vorerfahrung nötig.',
    category: 'Gastronomie',
    isNew: false,
    isFeatured: false,
    applicants: 1,
  },
  {
    id: 15,
    title: 'Aushilfe Eisdiele (Saisonal)',
    company: 'Welpig & Co UG',
    logo: null,
    location: 'Homburg',
    type: 'Minijob',
    salary: '12,00 €/Stunde',
    tags: ['Eis', 'Verkauf', 'saisonal', 'Sommer'],
    posted: 'Heute',
    description: 'Für die Sommersaison (Mai–September) suchen wir eine freundliche Aushilfe für unsere Eisdiele. Du verkaufst Eis, bereitest Eisbecher zu und sorgst für Sauberkeit an der Theke.',
    category: 'Gastronomie',
    isNew: true,
    isFeatured: false,
    applicants: 8,
  },
];

export const CATEGORIES = [
  { id: 1, name: 'Technologie', icon: '💻', count: 124 },
  { id: 2, name: 'Design', icon: '🎨', count: 87 },
  { id: 3, name: 'Marketing', icon: '📱', count: 65 },
  { id: 4, name: 'Gastronomie', icon: '☕', count: 203 },
  { id: 5, name: 'Einzelhandel', icon: '🛍️', count: 156 },
  { id: 6, name: 'Bildung', icon: '📚', count: 94 },
  { id: 7, name: 'Sport & Fitness', icon: '💪', count: 42 },
  { id: 8, name: 'Kunst & Kultur', icon: '🎭', count: 38 },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Lena K.',
    age: 19,
    role: 'Aushilfe bei Laxner Bäckerei',
    text: 'Über LetsCareers habe ich meinen ersten Job gefunden. Die Bewerbung war so einfach!',
    avatar: 'LK',
  },
  {
    id: 2,
    name: 'Noah B.',
    age: 22,
    role: 'IT-Praktikant bei Nexbar Systems',
    text: 'Der Chat mit dem Arbeitgeber war super – keine langen E-Mail-Ketten, einfach direkt!',
    avatar: 'NB',
  },
  {
    id: 3,
    name: 'Sara M.',
    age: 17,
    role: 'Barista bei Klumba Gastronomie',
    text: 'Perfekte Plattform für Jugendliche. Endlich Jobs, die zu mir passen!',
    avatar: 'SM',
  },
];

export const MESSAGES = [
  {
    id: 1,
    from: 'Zorbex Bildung GmbH',
    fromAvatar: 'ZB',
    message: 'Hallo! Wir haben deine Bewerbung erhalten und würden dich gerne kennenlernen.',
    time: '10:30',
    isOwn: false,
    jobTitle: 'Nachhilfelehrer/in Mathematik',
  },
  {
    id: 2,
    from: 'Du',
    fromAvatar: 'Du',
    message: 'Vielen Dank! Ich freue mich sehr auf ein Gespräch. Wann würde es passen?',
    time: '10:45',
    isOwn: true,
  },
  {
    id: 3,
    from: 'Zorbex Bildung GmbH',
    fromAvatar: 'ZB',
    message: 'Wie wäre es nächsten Dienstag um 14 Uhr für ein kurzes Telefonat?',
    time: '11:02',
    isOwn: false,
  },
];
